import { isProd, isTest } from './is-env'

export function generate<T = number>(
  length: number,
  cb: (index: number) => T = (i: number) => i as T,
): T[] {
  return Array.from({ length }, (_, i) => cb(i))
}

export function safe<T>(
  value: T | undefined | null,
  message = 'Value is undefined or null',
): T {
  if (value === undefined || value === null) {
    if (!(isProd || isTest)) {
      // oxlint-disable-next-line no-debugger -- for convienience
      debugger // do not remove
    }
    throw new Error(message)
  }
  return value
}

export const wait = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms)
  })

export const safeSplit = (str: string, sep: string | RegExp) => {
  const parts = str.split(sep)
  return parts.map((s) => s.trim()).filter(Boolean)
}

export const roundToTwo = (num: number) =>
  Math.round((num + Number.EPSILON) * 100) / 100

export function debounce<T extends (...args: unknown[]) => unknown>(
  fn: T,
  delay: number,
): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout> | undefined
  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}
